import callApi from 'services'

export default {
  getAllegedPerpetratorList() {
    return callApi('alleged-perpetrators', 'GET')
  },
}
